import React, { useState, useEffect, useContext } from "react";
import Popup from "../../Modal/Popup";
import { NavItem, NavLink, Nav, TabContent, TabPane, Alert } from "reactstrap";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import Counter from "../../Tool/Counter/Counter";
import ColorPicker from "../../Tool/ColorPicker/ColorPicker";
import classnames from "classnames";
import * as UTILS from "../../../utils/Utils";
import ButtonPreview from "./ButtonPreview";
import cloneDeep from "lodash.clonedeep";
import { Footer } from "../../Tool/LinkOption/components/common/Footer";
import { CustomElementsContext } from "../../../context/CustomElementsContext";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import Confirm from "../../Modal/Confirm";

const ButtonSettings = (props) => {
  const [state, setState] = useState({
    activeTabModal: "1",
  });
  const [error, setError] = useState(null);
  const [button, setButton] = useState({ ...props.button });
  const [preview, setPreview] = useState(false);
  const {
    customButtons,
    setCustomButtons,
    saveCustomButton,
    isLoading,
    postStatus,
    updateStatus,
  } = useContext(CustomElementsContext);
  const toggleModalTab = (tab) => {
    if (state.activeTabModal !== tab) {
      setState({
        activeTabModal: tab,
      });
    }
  };

  useEffect(() => {
       postStatus == "Success" || updateStatus == "Success"
         ? setTimeout(() => {
             props.setSelectedButton(null);
           }, 2000)
         : "";
  }, [props, button,postStatus,updateStatus]);

  const buttonFont = (
    <select
      style={{}}
      // className="selectFontFamily"
      type="text"
      placeholder="Select Font Family"
      value={button.custom_element_json.style.fontFamily}
      onChange={(e) => {
        setButton({
          ...button,

          custom_element_json: {
            ...button.custom_element_json,
            style: {
              ...button.custom_element_json.style,
              fontFamily: e.target.value,
            },
          },
        });
      }}
    >

      {UTILS.googleFonts.map((font) => (
        <option key={font.format} value={font.format}>
          {font.name}
        </option>
      ))}
    </select>
  );
  const buttonFontSize = (
    <div className="">
      <input
        type="text"
        name="buttonFontSize"
        value={
          button.custom_element_json.style.fontSize > 200
            ? 200
            : button.custom_element_json.style.fontSize
        }
        onChange={(e) => {
          setButton({
            ...button,
            custom_element_json: {
              ...button.custom_element_json,
              style: {
                ...button.custom_element_json.style,
                fontSize: e.target.value > 200 ? 200 : e.target.value,
              },
            },
          });
        }}
      />
    </div>
  );
  const buttonAlignment = (
    <select
      name="buttonAlignment"
      value={button.custom_element_json.style.float}
      onChange={(e) => {
        setButton({
          ...button,
          custom_element_json: {
            ...button.custom_element_json,
            style: {
              ...button.custom_element_json.style,
              float: e.target.value,
            },
          },
        });
      }}
    >
      <option value="left">Left</option>
      <option value="none">Center</option>
      <option value="right">Right</option>
    </select>
  );
  const buttonAlignmentMobile = (
    <select
      name="mobileButtonAlignment"
      value={button.custom_element_json.mobileAlignment}
      onChange={(e) => {
        setButton({
          ...button,
          custom_element_json: {
            ...button.custom_element_json,
            mobileAlignment: e.target.value,
          },
        });
      }}
    >
      <option defaultChecked value="left">
        Left
      </option>
      <option value="none">Center</option>
      <option value="right">Right</option>
    </select>
  );

  const handleError = (errorMessage) => {
    setError(errorMessage);
    setTimeout(() => setError(null), 3000);
  };
  const submitCustomButton = () => {
    button.custom_element_name == null || button.custom_element_name == ""
      ? (() => {
          handleError("Custom Button Name Must be defined");
        })()
      : button.custom_element_name && button.custom_element_name.length > 30
      ? (() => {
          handleError("Custom Button Name cannot exceed 30 characters");
        })()
      : (() => {
          saveCustomButton(button);
        })();
  };

  return (
    <Popup
      width="700"
      header={
        button.customElementID == null
          ? "Creating New Custom Button"
          : `Editing ${props.button.custom_element_name} Button...`
      }
      closePopup={() => {
        props.setSelectedButton(null);
      }}
      close={() => {
        props.setSelectedButton(null);
      }}
    >
      <div className={`previewContainer ` + (preview ? "open" : "close")}>
        {preview == true ? (
          <>
            <div
              onClick={() => {
                setPreview(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {" "}
              <ButtonPreview
                onClick={() => {
                  setPreview(false);
                }}
                button={button}
              />
              <p
                onClick={() => {
                  setPreview(false);
                }}
              >{` ${button.customElementID == null ? "Creating" : "Editing"} ${
                props.button.custom_element_name == null
                  ? "New Custom Button"
                  : props.button.custom_element_name
              }...`}</p>
            </div>
          </>
        ) : (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => {
              setPreview(true);
            }}
          >
            Preview
          </p>
        )}
      </div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({
              active: state.activeTabModal === "1",
            })}
            onClick={() => {
              toggleModalTab("1");
            }}
          >
            General
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: state.activeTabModal === "2",
            })}
            onClick={() => {
              toggleModalTab("2");
            }}
          >
            Normal
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: state.activeTabModal === "3",
            })}
            onClick={() => {
              toggleModalTab("3");
            }}
          >
            Hover
          </NavLink>
        </NavItem>
      </Nav>

      <div className="modalScrollContainer">
        <TabContent
          className="buttonSettingWrapper"
          activeTab={state.activeTabModal}
        >
          <TabPane tabId="1" className="general-tab">
            <div className="general-setting">
              <div className="">
                <div className="modalContentWrapper">
                  <label>Custom Button Name</label>
                  <input
                    style={{
                      paddingLeft: "5px",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          customElementName: e.target.value,
                        },
                        custom_element_name: e.target.value,
                      });
                    }}
                    defaultValue={props.button.custom_element_name}
                    placeholder="Add Button Label"
                    className="textInput"
                    type="text"
                  />
                  <label>Text Content</label>
                  <input
                    style={{
                      paddingLeft: "5px",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          content: e.target.value,
                        },
                        content: e.target.value,
                      });
                    }}
                    defaultValue={button.custom_element_json.content}
                    placeholder="Add Button Text Content"
                    className="textInput"
                    type="text"
                  />
                </div>
                <div className="wrap">
                  <div
                    className="padding-section"
                    style={{ marginBottom: "10px", marginTop: "20px" }}
                  >
                    <div className="heading">Font Settings</div>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="modalContentWrapper"
                  >
                    <div className="modalSetting">
                      <label>Font Family</label>
                      {buttonFont}
                    </div>
                    <div className="modalSetting">
                      <label>
                        Font Size <small>(Pixels)</small>
                      </label>
                      {buttonFontSize}
                    </div>
                    <div className="modalSetting">
                      <label htmlFor="button-font-weight-check">
                        Font Bold
                        <input
                          key={Math.random()}
                          id={"button-font-weight-check"}
                          type="checkbox"
                          name="fontWeight"
                          onChange={(e) => {
                            setButton({
                              ...button,
                              custom_element_json: {
                                ...button.custom_element_json,
                                style: {
                                  ...button.custom_element_json.style,
                                  fontWeight:
                                    e.target.checked === true
                                      ? "bold"
                                      : "normal",
                                },
                              },
                            });
                          }}
                          checked={
                            button.custom_element_json.style.fontWeight ===
                            "bold"
                              ? true
                              : false
                          }
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="">
                  <div
                    className="padding-section"
                    style={{ marginBottom: "10px", marginTop: "20px" }}
                  >
                    <div className="heading">Width and Alignment</div>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="modalContentWrapper"
                  >
                    <div className="modalSetting">
                      <label>Button Align for desktop</label>
                      {buttonAlignment}
                    </div>

                    <div className="modalSetting">
                      <label>Button Align for mobile</label>
                      {buttonAlignmentMobile}
                    </div>

                    <div className="modalSetting">
                      <label htmlFor="button-width-check">
                        100% Width
                        <input
                          key={Math.random()}
                          id={"button-width-check"}
                          type="checkbox"
                          style={{ display: "block" }}
                          name="width"
                          onChange={(e) => {
                            setButton({
                              ...button,
                              custom_element_json: {
                                ...button.custom_element_json,
                                style: {
                                  ...button.custom_element_json.style,
                                  width:
                                    e.target.checked === true ? "100%" : "auto",
                                  marginRight: "0",
                                  marginLeft:"0"
                                },
                              },
                            });


                          }}
                          checked={
                            button.custom_element_json.style.width === "100%"
                              ? true
                              : false
                          }
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="padding-section">
                <div
                  className="padding-section"
                  style={{ marginBottom: "5px" }}
                >
                  <div className="heading">Padding </div>
                </div>

                <div
                  className="heading-row modalContentWrapper"
                  style={{ justifyContent: "flex-end" }}
                >
                  <UnitSelector
                    defaultValue={
                      button.custom_element_json.style.btnPaddingUnit
                        ? button.custom_element_json.style.btnPaddingUnit
                        : "px"
                    }
                    onChange={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            btnPaddingUnit: e.target.value,
                          },
                        },
                      });
                    }}
                    value={button.custom_element_json.style.btnPaddingUnit}
                  />
                </div>

                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="modalContentWrapper"
                >
                  <div className="d-block">
                    <Counter
                      label="Top"
                      small={
                        button.custom_element_json.style.btnPaddingUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingTop:
                                Number(
                                  button.custom_element_json.style.paddingTop
                                ) -
                                  1 <
                                0
                                  ? 0
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingTop
                                    ) - 1,
                            },
                          },
                        });
                      }}
                      valueContent={
                        button.custom_element_json.style.paddingTop > 200
                          ? 200
                          : button.custom_element_json.style.paddingTop < 0
                          ? 0
                          : button.custom_element_json.style.paddingTop
                      }
                      disabled={false}
                      onChange={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingTop:
                                e.target.value > 200
                                  ? 200
                                  : e.target.value < 0
                                  ? 0
                                  : e.target.value,
                            },
                          },
                        });
                      }}
                      plusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingTop:
                                Number(
                                  button.custom_element_json.style.paddingTop
                                ) +
                                  1 >
                                200
                                  ? 200
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingTop
                                    ) + 1,
                            },
                          },
                        });
                      }}
                    />{" "}
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Bottom"
                      small={
                        button.custom_element_json.style.btnPaddingUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingBottom:
                                Number(
                                  button.custom_element_json.style.paddingBottom
                                ) -
                                  1 <
                                0
                                  ? 0
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingBottom
                                    ) - 1,
                            },
                          },
                        });
                      }}
                      valueContent={
                        button.custom_element_json.style.paddingBottom > 200
                          ? 200
                          : button.custom_element_json.style.paddingBottom < 0
                          ? 0
                          : button.custom_element_json.style.paddingBottom
                      }
                      disabled={false}
                      onChange={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingBottom:
                                e.target.value > 200
                                  ? 200
                                  : e.target.value < 0
                                  ? 0
                                  : e.target.value,
                            },
                          },
                        });
                      }}
                      plusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingBottom:
                                Number(
                                  button.custom_element_json.style.paddingBottom
                                ) +
                                  1 >
                                200
                                  ? 200
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingBottom
                                    ) + 1,
                            },
                          },
                        });
                      }}
                    />
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Left"
                      small={
                        button.custom_element_json.style.btnPaddingUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingLeft:
                                Number(
                                  button.custom_element_json.style.paddingLeft
                                ) -
                                  1 <
                                0
                                  ? 0
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingLeft
                                    ) - 1,
                            },
                          },
                        });
                      }}
                      valueContent={
                        button.custom_element_json.style.paddingLeft > 200
                          ? 200
                          : button.custom_element_json.style.paddingLeft < 0
                          ? 0
                          : button.custom_element_json.style.paddingLeft
                      }
                      disabled={false}
                      onChange={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingLeft:
                                e.target.value > 200
                                  ? 200
                                  : e.target.value < 0
                                  ? 0
                                  : e.target.value,
                            },
                          },
                        });
                      }}
                      plusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingLeft:
                                Number(
                                  button.custom_element_json.style.paddingLeft
                                ) +
                                  1 >
                                200
                                  ? 200
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingLeft
                                    ) + 1,
                            },
                          },
                        });
                      }}
                    />
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Right"
                      small={
                        button.custom_element_json.style.btnPaddingUnit === "%"
                          ? "percent"
                          : "pixel"
                      }
                      minusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingRight:
                                Number(
                                  button.custom_element_json.style.paddingRight
                                ) -
                                  1 <
                                0
                                  ? 0
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingRight
                                    ) - 1,
                            },
                          },
                        });
                      }}
                      valueContent={
                        button.custom_element_json.style.paddingRight > 200
                          ? 200
                          : button.custom_element_json.style.paddingRight < 0
                          ? 0
                          : button.custom_element_json.style.paddingRight
                      }
                      disabled={false}
                      onChange={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingRight:
                                e.target.value > 200
                                  ? 200
                                  : e.target.value < 0
                                  ? 0
                                  : e.target.value,
                            },
                          },
                        });
                      }}
                      plusClick={(e) => {
                        setButton({
                          ...button,
                          custom_element_json: {
                            ...button.custom_element_json,
                            style: {
                              ...button.custom_element_json.style,
                              paddingRight:
                                Number(
                                  button.custom_element_json.style.paddingRight
                                ) +
                                  1 >
                                200
                                  ? 200
                                  : Number(
                                      button.custom_element_json.style
                                        .paddingRight
                                    ) + 1,
                            },
                          },
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="clear" />
              </div>

              <div className="heading-row">
                <div
                  className="padding-section"
                  style={{ marginBottom: "5px" }}
                >
                  <div className="heading">Margin </div>
                </div>
              </div>
              <div
                className="heading-row modalContentWrapper"
                style={{ justifyContent: "flex-end" }}
              >
                <UnitSelector
                  defaultValue={
                    button.custom_element_json.style.btnMarginUnit
                      ? button.custom_element_json.style.btnMarginUnit
                      : "px"
                  }
                  onChange={(e) => {
                    setButton({
                      ...button,
                      custom_element_json: {
                        ...button.custom_element_json,
                        style: {
                          ...button.custom_element_json.style,
                          btnMarginUnit: e.target.value,
                        },
                      },
                    });
                  }}
                  value={button.custom_element_json.style.btnMarginUnit}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
                className="modalContentWrapper"
              >
                <div className="d-block">
                  <Counter
                    label="Top"
                    small={
                      button.custom_element_json.style.btnMarginUnit === "%"
                        ? "percent"
                        : "pixel"
                    }
                    minusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginTop:
                              Number(
                                button.custom_element_json.style.marginTop
                              ) -
                                1 <
                              0
                                ? 0
                                : Number(
                                    button.custom_element_json.style.marginTop
                                  ) - 1,
                          },
                        },
                      });
                    }}
                    valueContent={
                      button.custom_element_json.style.marginTop > 200
                        ? 200
                        : button.custom_element_json.style.marginTop < 0
                        ? 0
                        : button.custom_element_json.style.marginTop
                    }
                    disabled={false}
                    onChange={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginTop:
                              e.target.value > 200
                                ? 200
                                : e.target.value < 0
                                ? 0
                                : e.target.value,
                          },
                        },
                      });
                    }}
                    plusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginTop:
                              Number(
                                button.custom_element_json.style.marginTop
                              ) +
                                1 >
                              200
                                ? 200
                                : Number(
                                    button.custom_element_json.style.marginTop
                                  ) + 1,
                          },
                        },
                      });
                    }}
                  />{" "}
                </div>
                <div className="d-block">
                  <Counter
                    label="Bottom"
                    small={
                      button.custom_element_json.style.btnMarginUnit === "%"
                        ? "percent"
                        : "pixel"
                    }
                    minusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginBottom:
                              Number(
                                button.custom_element_json.style.marginBottom
                              ) -
                                1 <
                              0
                                ? 0
                                : Number(
                                    button.custom_element_json.style
                                      .marginBottom
                                  ) - 1,
                          },
                        },
                      });
                    }}
                    valueContent={
                      button.custom_element_json.style.marginBottom > 200
                        ? 200
                        : button.custom_element_json.style.marginBottom < 0
                        ? 0
                        : button.custom_element_json.style.marginBottom
                    }
                    disabled={false}
                    onChange={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginBottom:
                              e.target.value > 200
                                ? 200
                                : e.target.value < 0
                                ? 0
                                : e.target.value,
                          },
                        },
                      });
                    }}
                    plusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginBottom:
                              Number(
                                button.custom_element_json.style.marginBottom
                              ) +
                                1 >
                              200
                                ? 200
                                : Number(
                                    button.custom_element_json.style
                                      .marginBottom
                                  ) + 1,
                          },
                        },
                      });
                    }}
                  />
                </div>
                <div className="d-block">
                  <Counter
                    label="Left"
                    small={
                      button.custom_element_json.style.btnMarginUnit === "%"
                        ? "percent"
                        : "pixel"
                    }
                    minusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginLeft:
                              Number(
                                button.custom_element_json.style.marginLeft
                              ) -
                                1 <
                              0
                                ? 0
                                : Number(
                                    button.custom_element_json.style.marginLeft
                                  ) - 1,
                          },
                        },
                      });
                    }}
                    valueContent={
                      button.custom_element_json.style.marginLeft > 200
                        ? 200
                        : button.custom_element_json.style.marginLeft < 0
                        ? 0
                        : button.custom_element_json.style.marginLeft
                    }
                    disabled={button.custom_element_json.style.width == "100%"}
                    onChange={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginLeft:
                              e.target.value > 200
                                ? 200
                                : e.target.value < 0
                                ? 0
                                : e.target.value,
                          },
                        },
                      });
                    }}
                    plusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginLeft:
                              Number(
                                button.custom_element_json.style.marginLeft
                              ) +
                                1 >
                              200
                                ? 200
                                : Number(
                                    button.custom_element_json.style.marginLeft
                                  ) + 1,
                          },
                        },
                      });
                    }}
                  />
                </div>
                <div className="d-block">
                  <Counter
                    label="Right"
                    small={
                      button.custom_element_json.style.btnMarginUnit === "%"
                        ? "percent"
                        : "pixel"
                    }
                    minusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginRight:
                              Number(
                                button.custom_element_json.style.marginRight
                              ) -
                                1 <
                              0
                                ? 0
                                : Number(
                                    button.custom_element_json.style.marginRight
                                  ) - 1,
                          },
                        },
                      });
                    }}
                    valueContent={
                      button.custom_element_json.style.marginRight > 200
                        ? 200
                        : button.custom_element_json.style.marginRight < 0
                        ? 0
                        : button.custom_element_json.style.marginRight
                    }
                    disabled={button.custom_element_json.style.width == "100%"}
                    onChange={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginRight:
                              e.target.value > 200
                                ? 200
                                : e.target.value < 0
                                ? 0
                                : e.target.value,
                          },
                        },
                      });
                    }}
                    plusClick={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          style: {
                            ...button.custom_element_json.style,
                            marginRight:
                              Number(
                                button.custom_element_json.style.marginRight
                              ) +
                                1 >
                              200
                                ? 200
                                : Number(
                                    button.custom_element_json.style.marginRight
                                  ) + 1,
                          },
                        },
                      });
                    }}
                  />
                </div>
              </div>

              <div className="padding-section">
                <div className="heading">Border</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="modalContentWrapper"
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "50%",
                    }}
                  >
                    <div className="d-block">
                      <Counter
                        label="Border Width"
                        minusClick={(e) => {
                          setButton({
                            ...button,
                            custom_element_json: {
                              ...button.custom_element_json,
                              style: {
                                ...button.custom_element_json.style,
                                borderWidth:
                                  Number(
                                    button.custom_element_json.style.borderWidth
                                  ) -
                                    1 <
                                  0
                                    ? 0
                                    : Number(
                                        button.custom_element_json.style
                                          .borderWidth
                                      ) - 1,
                              },
                            },
                          });
                        }}
                        valueContent={
                          button.custom_element_json.style.borderWidth > 50
                            ? 50
                            : button.custom_element_json.style.borderWidth < 0
                            ? 0
                            : button.custom_element_json.style.borderWidth
                        }
                        disabled={false}
                        onChange={(e) => {
                          setButton({
                            ...button,
                            custom_element_json: {
                              ...button.custom_element_json,
                              style: {
                                ...button.custom_element_json.style,
                                borderWidth:
                                  e.target.value > 50
                                    ? 50
                                    : e.target.value < 0
                                    ? 0
                                    : e.target.value,
                              },
                            },
                          });
                        }}
                        plusClick={(e) => {
                          setButton({
                            ...button,
                            custom_element_json: {
                              ...button.custom_element_json,
                              style: {
                                ...button.custom_element_json.style,
                                borderWidth:
                                  Number(
                                    button.custom_element_json.style.borderWidth
                                  ) +
                                    1 >
                                  50
                                    ? 50
                                    : Number(
                                        button.custom_element_json.style
                                          .borderWidth
                                      ) + 1,
                              },
                            },
                          });
                        }}
                      />
                    </div>

                    <div className="d-block">
                      <Counter
                        label="Border Radius"
                        minusClick={(e) => {
                          setButton({
                            ...button,
                            custom_element_json: {
                              ...button.custom_element_json,
                              style: {
                                ...button.custom_element_json.style,
                                borderRadius:
                                  Number(
                                    button.custom_element_json.style
                                      .borderRadius
                                  ) -
                                    1 <
                                  0
                                    ? 0
                                    : Number(
                                        button.custom_element_json.style
                                          .borderRadius
                                      ) - 1,
                              },
                            },
                          });
                        }}
                        valueContent={
                          button.custom_element_json.style.borderRadius > 1000
                            ? 1000
                            : button.custom_element_json.style.borderRadius < 0
                            ? 0
                            : button.custom_element_json.style.borderRadius
                        }
                        disabled={false}
                        onChange={(e) => {
                          setButton({
                            ...button,
                            custom_element_json: {
                              ...button.custom_element_json,
                              style: {
                                ...button.custom_element_json.style,
                                borderRadius:
                                  e.target.value > 1000
                                    ? 1000
                                    : e.target.value < 0
                                    ? 0
                                    : e.target.value,
                              },
                            },
                          });
                        }}
                        plusClick={(e) => {
                          setButton({
                            ...button,
                            custom_element_json: {
                              ...button.custom_element_json,
                              style: {
                                ...button.custom_element_json.style,
                                borderRadius:
                                  Number(
                                    button.custom_element_json.style
                                      .borderRadius
                                  ) +
                                    1 >
                                  1000
                                    ? 1000
                                    : Number(
                                        button.custom_element_json.style
                                          .borderRadius
                                      ) + 1,
                              },
                            },
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="clear" />
              </div>

              <div className="clear" />
            </div>
          </TabPane>
          <TabPane tabId="2" className="normal-tab">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
              className="modalContentWrapper"
            >
              <div style={{ width: "300px", marginRight: "20px" }}>
                <ColorPicker
                  btnLabel=" Text Color"
                  colorValue={button.custom_element_json.normalBtn.txtColor.rgb}
                  colorDefaultValue={
                    button.custom_element_json.normalBtn.txtColor.rgb
                  }
                  getColor={(e) => {
                    setButton({
                      ...button,
                      custom_element_json: {
                        ...button.custom_element_json,
                        normalBtn: {
                          ...button.custom_element_json.normalBtn,
                          txtColor: { rgb: e.rgb, hex: e.hex },
                        },
                      },
                    });
                  }}
                />
              </div>

              <div style={{ width: "300px" }}>
                {" "}
                <ColorPicker
                  btnLabel=" Background Color"
                  colorValue={button.custom_element_json.normalBtn.btnBG.rgb}
                  colorDefaultValue={
                    button.custom_element_json.normalBtn.btnBG.rgb
                  }
                  getColor={(e) => {
                    setButton({
                      ...button,
                      custom_element_json: {
                        ...button.custom_element_json,
                        normalBtn: {
                          ...button.custom_element_json.normalBtn,
                          btnBG: { rgb: e.rgb, hex: e.hex },
                        },
                      },
                    });
                  }}
                />
              </div>

              <div style={{ width: "300px" }}>
                {" "}
                <ColorPicker
                  btnLabel=" Border Color"
                  colorValue={
                    button.custom_element_json.normalBtn.btnBorder.rgb
                  }
                  colorDefaultValue={
                    button.custom_element_json.normalBtn.btnBorder.rgb
                  }
                  getColor={(e) => {
                    setButton({
                      ...button,
                      custom_element_json: {
                        ...button.custom_element_json,
                        normalBtn: {
                          ...button.custom_element_json.normalBtn,
                          btnBorder: { rgb: e.rgb, hex: e.hex },
                        },
                      },
                    });
                  }}
                />
              </div>
            </div>
          </TabPane>
          <TabPane tabId="3" className="hover-tab">
            <div className="modalContentWrapper">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ width: "300px", marginRight: "20px" }}>
                  {" "}
                  <ColorPicker
                    btnLabel="Text Color"
                    colorValue={
                      button.custom_element_json.hoverBtn.txtColor.rgb
                    }
                    colorDefaultValue={
                      button.custom_element_json.hoverBtn.txtColor.rgb
                    }
                    getColor={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          hoverBtn: {
                            ...button.custom_element_json.hoverBtn,
                            txtColor: { rgb: e.rgb, hex: e.hex },
                          },
                        },
                      });
                    }}
                  />
                </div>

                <div style={{ width: "300px", marginRight: "20px" }}>
                  {" "}
                  <ColorPicker
                    btnLabel="Background Color"
                    colorValue={button.custom_element_json.hoverBtn.btnBg.rgb}
                    colorDefaultValue={
                      button.custom_element_json.hoverBtn.btnBg.rgb
                    }
                    getColor={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          hoverBtn: {
                            ...button.custom_element_json.hoverBtn,
                            btnBg: { rgb: e.rgb, hex: e.hex },
                          },
                        },
                      });
                    }}
                  />
                </div>

                <div style={{ width: "300px", marginRight: "20px" }}>
                  {" "}
                  <ColorPicker
                    btnLabel="Border Color"
                    colorValue={
                      button.custom_element_json.hoverBtn.btnBorder.rgb
                    }
                    colorDefaultValue={
                      button.custom_element_json.hoverBtn.btnBorder.rgb
                    }
                    getColor={(e) => {
                      setButton({
                        ...button,
                        custom_element_json: {
                          ...button.custom_element_json,
                          hoverBtn: {
                            ...button.custom_element_json.hoverBtn,
                            btnBorder: { rgb: e.rgb, hex: e.hex },
                          },
                        },
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </TabPane>
        </TabContent>
      </div>
      {error !== null ? (
        <Alert
          color="danger"
          className="flimpalert"
          fade={true}
          style={{ textAlign: "center", position: "absolute", zIndex: "3" }}
          // toggle={onDismissDelete}
        >
          {error}
        </Alert>
      ) : postStatus == "error" ? (
        <Alert
          color="danger"
          className="flimpalert"
          fade={true}
          style={{ textAlign: "center", position: "absolute", zIndex: "3" }}
          // toggle={onDismissDelete}
        >
          There was an error submitting your content. Custom element names
          cannot be repeated.
        </Alert>
      ) : updateStatus == "error" ? (
        <Alert
          color="danger"
          className="flimpalert"
          fade={true}
          style={{ textAlign: "center", position: "absolute", zIndex: "3" }}
          // toggle={onDismissDelete}
        >
          There was an error updating your content. Custom element names cannot
          be repeated.
        </Alert>
      ) : (
        ""
      )}
      <Footer
        title={"Save Custom Button"}
        confirmMessage={
          "Are you sure you want to save these custom element settings?"
        }
        isSaving={isLoading}
        onSave={() => {
          submitCustomButton();
        }}
        onCancel={() => {
          props.setSelectedButton(null);
        }}
      />
    </Popup>
  );
};

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    layoutList: state.present.layoutList,
    canvasStyle: state.present.canvasStyle,
    elementsFont: state.present.canvasStyle.elementsFont,
    columnGap: state.present.canvasStyle.columnGap,
    rowGap: state.present.canvasStyle.rowGap,
    canvasRowsPaddingUnit: state.present.canvasStyle.canvasRowsPaddingUnit,
    enableWidthForRow: state.present.enableWidthForRow,
    canvasRowsPadding: state.present.canvasStyle.canvasRowsPadding,
    containerWidth: state.present.containerWidth,
    canvasRowsPaddingMobile: state.present.canvasStyle.canvasRowsPaddingMobile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutListArray: (layoutList) =>
      dispatch(actionTypes.set_layout_list(layoutList)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ButtonSettings);
